// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kH3l","left":"styles_left__3C0tR","desktopActions":"styles_desktopActions__1aGYr","title":"styles_title__DPmjF"};